/**
 * OwnershipCard — Vault item ownership confirmation card
 * MAESTRO:P1D · Relocated to vault/ for MAESTRO:P8B
 *
 * Renders vault item ownership: title, issue number, grade, grading company,
 * box name, box position. Orange left border for owned items.
 */

export default function OwnershipCard({ data }) {
  if (!data) return null;

  const { title, grade, box_name, grading_company, issue_number, cost_basis, current_value } = data;

  return (
    <div
      className="bg-zinc-900 border-l-4 border-orange-500 rounded-lg p-4 my-2"
      role="region"
      aria-label={`Ownership card for ${title || 'item'}`}
    >
      <div className="flex items-center gap-2 mb-2">
        <span className="text-orange-500 font-bold text-xs uppercase tracking-wider">
          You Own This
        </span>
      </div>

      <h4 className="text-white font-semibold text-sm">
        {title}
        {issue_number && <span className="text-zinc-400 ml-1">#{issue_number}</span>}
      </h4>

      <div className="flex flex-wrap gap-3 mt-2 text-xs text-zinc-400">
        {grade && (
          <span className="bg-zinc-800 px-2 py-1 rounded">
            Grade: <span className="text-white">{grade}</span>
          </span>
        )}
        {grading_company && (
          <span className="bg-zinc-800 px-2 py-1 rounded">
            {grading_company}
          </span>
        )}
        {box_name && (
          <span className="bg-zinc-800 px-2 py-1 rounded">
            Box: <span className="text-white">{box_name}</span>
          </span>
        )}
      </div>

      {(cost_basis || current_value) && (
        <div className="flex gap-4 mt-3 text-xs">
          {cost_basis && (
            <span className="text-zinc-400">
              Paid: <span className="text-white">${cost_basis}</span>
            </span>
          )}
          {current_value && (
            <span className="text-zinc-400">
              Worth: <span className="text-green-400">${current_value}</span>
            </span>
          )}
        </div>
      )}
    </div>
  );
}
